import React, { Component } from 'react';
import PropTypes from 'prop-types';
import WizardMenuItem from './WizardMenuItem';
import styles from './Wizard.scss';

export default class Wizard extends Component {
  static propTypes = {
    onStepChange: PropTypes.func.isRequired,
    currentStep: PropTypes.number,
    location: PropTypes.string,
    history: PropTypes.object,
    steps: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        component: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
        path: PropTypes.string,
        accessible: PropTypes.bool.isRequired,
        completed: PropTypes.bool.isRequired,
      })
    ).isRequired,
    additionalStepProps: PropTypes.object,
    hideNextSteps: PropTypes.bool,
    children: PropTypes.node,
  };

  static defaultProps = {
    location: '',
    currentStep: null,
    hideNextSteps: false,
    additionalStepProps: {},
  };

  currentStep() {
    return this.props.steps[this.props.currentStep - 1];
  }

  renderCurrentStep() {
    return React.cloneElement(this.currentStep().component, {
      onStepChange: this.props.onStepChange,
      history: this.props.history,
      ...this.props.additionalStepProps
    });
  }

  isStepActive(step, index) {
    return this.props.location ? step.path.indexOf(this.props.location) > -1 : index+1 === this.props.currentStep;
  }

  hasActiveStepErrors(){
    let hasErrors = false;

    this.props.steps.forEach((step, index) => {
      if (this.isStepActive(step, index)){
        hasErrors = this.props.submissionForm && this.props.submissionForm.getIn(['steps', step.path.substring(1), 'errors']).size > 0;
      }
    });

    return hasErrors;
  }

  renderProgressMenu() {
    const items = this.props.steps.map((step, index) =>
      <WizardMenuItem
        step={step}
        key={index}
        accessible={false}
        hasErrors={this.hasActiveStepErrors()}
        onClick={step.onClick}
        isActive={this.isStepActive(step, index)}
        stepId={index+1}
      />
    );

    return (
      <div className={`${styles.wizard} row no-gutters d-flex justify-content-center`}>
        <ul className={`${styles.items} col-12 col-sm-8 d-flex justify-content-center align-items-center justify-content-between`}>
          {items}
        </ul>
      </div>
    );
  }

  render() {
    const { snapSell } = this.props.additionalStepProps;
    return (
      <div className={styles.wizardContainer}>
        {!snapSell && this.renderProgressMenu()}
        {this.props.children ? this.props.children : this.renderCurrentStep()}
      </div>
    );
  }

}



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/Wizard.jsx